import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../helpers/Spinner/Spinner';
import i18next from '../services/i18n';
import pictureOrderActions, { pickRedirectOrder } from '../actions/pictureOrderActions';

class Home extends PureComponent {
  async UNSAFE_componentWillMount() {
    try {
      const { history, location, userId } = this.props;
      const search = (location && location.search) || '';

      if (!userId) {
        return false;
      }
      const orders = await pictureOrderActions.getUserOrdersAfterDayWithMessedOrders(userId);

      // Redirect to shop if no user has no orders yet
      if (!orders || orders.length === 0) {
        return history.replace(`/${global.language}/shop`);
      }

      const lastOrder = pickRedirectOrder(orders);

      const searchParams = new URLSearchParams(search);
      let url = lastOrder
        ? `/${global.language}/order/${lastOrder.orderId}${search && '/' + search}`
        : `/${global.language}/shop`;
      console.log(search);
      if (searchParams.get('redirect')) {
        url = `/${global.language}${searchParams.get('redirect') && '/' + searchParams.get('redirect')}`;
      }
      return history.replace(url);
    } catch (error) {
      const { handleError } = this.props;

      return handleError(i18next.t('NoOrderAvailable.message'));
    }
  }

  render() {
    return <Spinner />;
  }
}

Home.propTypes = {
  handleError: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};

export default Home;
